import React from 'react';
import { Layout, Menu, Typography } from 'antd';
import {
  DashboardOutlined,
  FileAddOutlined,
  DatabaseOutlined,
} from '@ant-design/icons';
import { Link, useLocation } from 'react-router-dom';

const { Sider } = Layout;
const { Title } = Typography;

// It accepts `collapsed` and `setCollapsed` to sync with the parent layout.
const SalesManagerSidebar = ({ collapsed, setCollapsed }) => {
  const location = useLocation();

  // This function determines which sub-menu should be open based on the current URL path.
  const getOpenKeys = () => {
    const currentPath = location.pathname;
    if (currentPath.includes('/sales/list') || currentPath.includes('/sales/search') || currentPath.includes('/sales/transfer') || currentPath.includes('/sales/accept')) {
      return ['inventory'];
    }
    if (currentPath.includes('/sales/new-sale') || currentPath.includes('/sales/new-buyandsale') || currentPath.includes('/sales/proforma')) {
      return ['sales'];
    }
    return [];
  };

  return (
    <Sider
      // --- PROPERTIES COPIED FROM INVENTORYSIDEBAR ---
      collapsible
      collapsed={collapsed}
      onCollapse={(value) => setCollapsed(value)} // This allows the Sider's own trigger to work
      width={250}
      breakpoint="lg"        // Automatically collapses on screens smaller than 'lg' (992px)
      collapsedWidth="0"     // Fully hides the sidebar on small screens
      style={{ minHeight: '100vh' }}
    >
      {/* --- TITLE STYLE COPIED FROM INVENTORYSIDEBAR --- */}
      <div style={{ textAlign: 'center', padding: '16px' }}>
        <Title level={4} style={{ color: 'white', margin: 0 }}>
          JS-Sales
        </Title>
      </div>

      <Menu
        theme="dark"
        mode="inline"
        // Set the open sub-menus based on the current URL
        defaultOpenKeys={getOpenKeys()}
        // Set the selected menu item based on the current URL
        selectedKeys={[location.pathname]}
      >
        {/* Dashboard */}
        <Menu.Item key="/sales/dashboard" icon={<DashboardOutlined />}>
          <Link to="/sales/dashboard">Dashboard</Link>
        </Menu.Item>

        {/* Inventory Management */}
      

        {/* Sales */}
        <Menu.SubMenu key="sales" title="Sales" icon={<FileAddOutlined />}>
          <Menu.Item key="/sales/new-sale">
            <Link to="/sales/new-sale">Add New Sale</Link>
          </Menu.Item>
          <Menu.Item key="/sales/new-buyandsale">
            <Link to="/sales/new-buyandsale">Add New Buy & Sale</Link>
          </Menu.Item>
           <Menu.Item key="/sales/collect-credit">
            <Link to="/sales/collect-credit">Collect Credit</Link>
          </Menu.Item>
          <Menu.Item key="/sales/proforma">
            <Link to="/sales/proforma">Create Proforma</Link>
          </Menu.Item>
            <Menu.Item key="/sales/allproforma">
            <Link to="/sales/allproforma">All Proforma</Link>
          </Menu.Item>
        </Menu.SubMenu>
          <Menu.SubMenu key="inventory" title="Inventory" icon={<DatabaseOutlined />}>
         
          <Menu.Item key="/sales/search">
            <Link to="/sales/search">Search & Send  Request</Link>
          </Menu.Item>
          <Menu.Item key="/sales/transfer">
            <Link to="/sales/transfer">Transfer Spare</Link>
          </Menu.Item>
          <Menu.Item key="/sales/accept">
            <Link to="/sales/accept">Accept Spare</Link>
          </Menu.Item>
        </Menu.SubMenu>
      
        <Menu.Item key="/sales/customer-notification">
          <Link to="/sales/customer-notification">Customer Info</Link>
        </Menu.Item>
      </Menu> 
    </Sider>
  );
};

export default SalesManagerSidebar;